export enum ReportQuestionnairesTableColumnDataIndex {
  Questionnaire = "questionnaire",
  Id = "id",
  Options = "options",
}
